import { IFounderSpotlight } from '../founder-spotlight/types';
import logoAndreesseenhHorowitz from './assets/logo-andreesseen-horowitz.png';
import logoBeacons from './assets/logo-beacons.png';
import logoBobbie from './assets/logo-bobbie.png';
import logoCoatue from './assets/logo-coatue.png';
import logoFirstRound from './assets/logo-first-round.png';
import logoMaven from './assets/logo-maven.png';
import logoRevolut from './assets/logo-revolut.png';
import logoSoftBank from './assets/logo-softbank.png';
import logoVMG from './assets/logo-vmg.png';
import logoYCombinator from './assets/logo-y-combinator.png';
import photoGaganBiyaniX1 from './assets/photo-gagan-biyani@1x.jpg';
import photoGaganBiyaniX2 from './assets/photo-gagan-biyani@2x.jpg';
import photoLauraModiX1 from './assets/photo-laura-modi@1x.jpg';
import photoLauraModiX2 from './assets/photo-laura-modi@2x.jpg';
import photoNealJeanX1 from './assets/photo-neal-jean@1x.jpg';
import photoNealJeanX2 from './assets/photo-neal-jean@2x.jpg';
import photoNikolayStoronskyX1 from './assets/photo-nikolay-storonsky@1x.jpg';
import photoNikolayStoronskyX2 from './assets/photo-nikolay-storonsky@2x.jpg';

export const FOUNDER_SPOTLIGHTS: IFounderSpotlight[] = [
  {
    company: 'Revolut',
    logo: logoRevolut,
    industry: 'Fintech',
    raised: '$1.8B+',
    backedBy: [
      {
        name: 'Coatue',
        logo: logoCoatue,
      },
      {
        name: 'SoftBank',
        logo: logoSoftBank,
      },
    ],
    quote:
      'From start to finish, [Republic] treated our company as if it were their own and took away the burden that comes with raising large sums of money from a large number of investors.',
    author: 'Nikolay Storonsky',
    authorPosition: 'CEO',
    authorPhoto: {
      url: photoNikolayStoronskyX1,
      url2x: photoNikolayStoronskyX2,
    },
  },
  {
    company: 'Bobbie',
    logo: logoBobbie,
    industry: 'Consumer',
    raised: '$142M+',
    backedBy: [
      {
        name: 'VMG',
        logo: logoVMG,
      },
    ],
    quote:
      "Many have asked me, was it worth it? YES. 200 of Bobbie's customers are now investors in our company. Worth. Every. Ounce. And... they got to invest alongside Laura Dern.",
    author: 'Laura Modi',
    authorPosition: 'CEO',
    authorPhoto: {
      url: photoLauraModiX1,
      url2x: photoLauraModiX2,
    },
  },
  {
    company: 'Maven',
    logo: logoMaven,
    industry: 'Education',
    raised: '$21M+',
    backedBy: [
      {
        name: 'Andreessen Horowitz',
        logo: logoAndreesseenhHorowitz,
      },
      {
        name: 'First Round',
        logo: logoFirstRound,
      },
    ],
    quote:
      'Republic helped us connect with our most ardent supporters before we even launched. Our crowdfunding investment is one of the highest ROI items on our cap table.',
    author: 'Gagan Biyani',
    authorPosition: 'CEO',
    authorPhoto: {
      url: photoGaganBiyaniX1,
      url2x: photoGaganBiyaniX2,
    },
  },
  {
    company: 'Beacons',
    logo: logoBeacons,
    industry: 'Creator Economy',
    raised: '$30M+',
    backedBy: [
      {
        name: 'Andreessen Horowitz',
        logo: logoAndreesseenhHorowitz,
      },
      {
        name: 'Y Combinator',
        logo: logoYCombinator,
      },
    ],
    quote:
      'With this money, we’ll be able to grow even faster as we continue to help creators build the businesses of tomorrow.',
    author: 'Neal Jean',
    authorPosition: 'CEO',
    authorPhoto: {
      url: photoNealJeanX1,
      url2x: photoNealJeanX2,
    },
  },
];
